module.exports = __webpack_public_path__ + "static/media/replace-image-tool.e97bfacf.svg";